import { gql } from 'graphql-tag'

export const GET_LEGAL_REPORT_TEMPLATE_OPTIONS_QUERY = gql`
  query GET_LEGAL_REPORT_TEMPLATE_OPTIONS_QUERY(
    $legalReportType: LegalReportType!
  ) {
    getLegalReportTemplateOptions(legalReportType: $legalReportType)
  }
`
